import { render } from "./AdminBlogs.vue?vue&type=template&id=f1783ca6&scoped=true"
import script from "./AdminBlogs.vue?vue&type=script&lang=js"
export * from "./AdminBlogs.vue?vue&type=script&lang=js"

import "./AdminBlogs.vue?vue&type=style&index=0&id=f1783ca6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1783ca6"]])

export default __exports__